import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

export default function SEOHead({
  title = "KerneViden",
  description = "Mennekser regulerer sig forskelligt. Derfor starter jeg der, hvor du er. Det er ikke vigtigt for mig hvordan du er, men hvordan du har det.",
  ogImage = "https://assets.auxodev.dk/assets/1d30bca3-a748-4ede-8335-828014d68a29/fullsizerender-4_aa527c92.jpeg",
  ogTitle,
  ogDescription,
  canonical,
}) {
  const location = useLocation();
  const currentUrl = canonical || `https://www.kerneviden.dk${location.pathname}`;
  const finalOgTitle = ogTitle || title;
  const finalOgDescription = ogDescription || description;

  return (
    <Helmet>
      <html lang="da" />
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={currentUrl} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDescription} />
      <meta name="twitter:image" content={ogImage} />
      
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
}
